"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Types_1 = require("@/Types");
const styled = __importStar(require("./styled"));
const Checkbox_1 = __importDefault(require("@/Components/UI/Checkbox"));
const useDevice_1 = require("@/Hooks/useDevice");
const FamilyPage_1 = require("@/Components/Page/FamilyPage/FamilyPage");
const Text_1 = __importDefault(require("./Text/Text"));
const Image_1 = __importDefault(require("./Image/Image"));
const gtmEvents_1 = require("@/DataLayer/gtmEvents");
const LIST_NAME = 'Product Listing Page';
const InfoBlock = ({ variant, type, isCompareLoading, compareProductPartNumbers, setCompareProductPartNumbers, withCompareFunctionality, isOpen, setIsOpen, showMoreButton, listRef, canSeePrice, breadcrumbs }) => {
    const { imageUrl, url, productUrl, partNumber, productName } = variant;
    const { isDesktopSmall4 } = (0, useDevice_1.useDevice)();
    const imageProductUrl = url || productUrl;
    const callSelectItemDataLayer = () => {
        if (!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length))
            return;
        const newBreadcrumbs = [...breadcrumbs];
        newBreadcrumbs.length = newBreadcrumbs.length + 1;
        (0, gtmEvents_1.selectItemEvent)([
            Object.assign(Object.assign({}, variant), { breadcrumbs: newBreadcrumbs })
        ], LIST_NAME);
    };
    const toggleCompareItems = (checked) => {
        if (checked) {
            setCompareProductPartNumbers(prev => {
                return [...prev, partNumber];
            });
        }
        else {
            setCompareProductPartNumbers(prev => prev === null || prev === void 0 ? void 0 : prev.filter(el => el !== partNumber));
        }
    };
    return (react_1.default.createElement(styled.InfoBlock, { variantType: type },
        react_1.default.createElement(Image_1.default, { variantType: type, url: imageProductUrl, imageUrl: imageUrl, productName: productName, onClick: callSelectItemDataLayer }),
        withCompareFunctionality && type === Types_1.VariantTypes.FULL_VIEW && !isDesktopSmall4 && (react_1.default.createElement(Checkbox_1.default, { checked: compareProductPartNumbers.includes(partNumber), onChange: e => toggleCompareItems(e.target.checked), disabled: isCompareLoading ||
                ((compareProductPartNumbers === null || compareProductPartNumbers === void 0 ? void 0 : compareProductPartNumbers.length) === FamilyPage_1.COMPARE_LIMIT &&
                    !compareProductPartNumbers.some(product => product === partNumber)) })),
        react_1.default.createElement(Text_1.default, { type: type, showMoreButton: showMoreButton, listRef: listRef, canSeePrice: canSeePrice, isOpen: isOpen, setIsOpen: setIsOpen, variant: variant, onClick: callSelectItemDataLayer })));
};
exports.default = InfoBlock;
